export function sleep(delay: number): Promise<void> {
	return new Promise(resolve => {
		setTimeout(resolve, delay)
	})
}

export function waitForUIUpdate(): Promise<void> {
	return new Promise(resolve => {
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => resolve())
		})
	})
}
